import "../../../../../styles/Pages/Financial/CashInFlow/Fees/AllFeesCollection.style.css";
import CustomTable from "../../../../Universal/CustomTable.component";
import AllCollectionSearchBox from "./AllCollectionSearchBox.component";

const AllFeesCollection = () => {
  const headers = [
    "Receipt Id/Time",
    "Amount/Mode",
    "Purpose",
    "Profile",
    "Signatory",
    "Receipt",
  ];

  const data = [
    {
      receiptId: "23457289056",
      date: "27 Dec, 2024",
      time: "10:24 AM",
      amount: "₹3400",
      mode: "UPI",
      purpose: "Admission",
      profile: "Toufik Alam",
      class: "5/B",
      profileId: "#SM0523019",
      signatory: "Jaheer Ahmad",
    },
    {
      receiptId: "23457289056",
      date: "27 Dec, 2024",
      time: "10:24 AM",
      amount: "₹1200",
      mode: "Cash",
      purpose: "Development fees",
      profile: "Toufik Alam ",
      class: "5/B",
      profileId: "#SM0523019",
      signatory: "Jaheer Ahmad",
    },
    {
      receiptId: "23457289056",
      date: "27 Dec, 2024",
      time: "10:24 AM",
      amount: "₹600",
      mode: "Check",
      purpose: "Medical charges",
      profile: "Toufik Alam ",
      class: "5/B",
      profileId: "#SM0523019",
      signatory: "Jaheer Ahmad",
    },
    {
      receiptId: "23457289056",
      date: "27 Dec, 2024",
      time: "10:24 AM",
      amount: "₹2300",
      mode: "Net banking",
      purpose: "Monthly fees",
      profile: "Toufik Alam",
      class: "5/B",
      profileId: "#SM0523019",
      signatory: "Jaheer Ahmad",
    },
    {
      receiptId: "23457289056",
      date: "27 Dec, 2024",
      time: "10:24 AM",
      amount: "₹2300",
      mode: "Cash",
      purpose: "Monthly fees",
      profile: "Toufik Alam",
      class: "5/B",
      profileId: "#SM0523019",
      signatory: "Jaheer Ahmad",
    },
    {
      receiptId: "23457289056",
      date: "27 Dec, 2024",
      time: "10:24 AM",
      amount: "₹2300",
      mode: "Cash",
      purpose: "Monthly fees",
      profile: "Toufik Alam",
      class: "5/B",
      profileId: "#SM0523019",
      signatory: "Jaheer Ahmad",
    },
  ];
  return (
    <div className="allFeesCollectionContainer">
      <div className="search-box">
        <AllCollectionSearchBox />
        <CustomTable
          headers={headers}
          data={data}
          renderFooterElement={
            <div className="custom-table-footer">
              <div id="totalCount">Total Count: 236</div>
              <div id="totalAmount">
                Total Amount:{" "}
                <span style={{ color: "var(--tableColor)" }}>₹2,60,560</span>
              </div>
            </div>
          }
        />
      </div>
    </div>
  );
};

export default AllFeesCollection;
